import React from 'react'
import { StyledExternalLink } from './_styled/external-link.styled'
import Text from './text'
import { Chevron } from './_styled/link.styled'

const sizeTextTypeMap = {
  extraSmall: 'bodyXs',
  small: 'bodySm',
  medium: 'body',
}

const ExternalLink = ({
  chevron,
  reversedChevron,
  color,
  onClick,
  text,
  to,
  type,
  underline,
  ...otherProps
}) => {
  const as = to ? null : (onClick && 'button') || 'span'
  const href = to === undefined || to === '' || to.endsWith('/') || to.startsWith('mailto:') ? to : `${to}/`
  return (
    <StyledExternalLink
      as={as}
      onClick={onClick}
      href={href}
      underline={underline}
      {...otherProps}
    >
      {(chevron || reversedChevron) && (
        <Chevron
          type="chevronRight"
          color={`${color || 'petrolBlue'}`}
          size="small"
          rotation={reversedChevron && 180}
        />
      )}
      <Text
        text={text}
        type={type ? sizeTextTypeMap[type] : 'body'}
        as="span"
        color={`${color || 'petrolBlue'}`}
      />
    </StyledExternalLink>
  )
}

export default ExternalLink
